/**
 * Shared object-workbench chrome for non-frozen desks.
 * Soft≠Live: paints gap / next / verify — never invents readiness.
 */
import { html, M, SOFT } from "./ui.js";

/** Horizontal prep spine — one current object, facets as steps. */
export function PrepSpine({ steps, activeId, onPick, label }) {
  const rows = Array.isArray(steps) ? steps : [];
  return html`<ol className="obj-wb__prep" aria-label=${label || "Preparation"}>
    ${rows.map((step, i) => {
      const on = step.id === activeId;
      const done = !!step.done;
      return html`<li key=${step.id} data-on=${on ? "1" : "0"} data-done=${done ? "1" : "0"}>
        <button type="button" onClick=${() => onPick && onPick(step.id)}>
          <i>${done ? "✓" : (i + 1)}</i>
          <b>${step.label}</b>
          <small>${step.say || ""}</small>
        </button>
      </li>`;
    })}
  </ol>`;
}

/** Current-object card (AI team · board · skill · automation · campaign). */
export function ObjectCard({ kind, title, meta, status }) {
  return html`<aside className="obj-wb__object" data-kind=${kind || "object"} aria-label="Current object">
    <small>${kind || "Object"}</small>
    <b>${title || "—"}</b>
    <em>${meta || ""}</em>
    ${status ? html`<span className="obj-wb__pill" data-on=${status.on ? "1" : "0"}>${status.label}</span>` : null}
  </aside>`;
}

/** Runtime nodes: Configured → … → Verified */
export function RuntimeRail({ steps, next }) {
  const rows = Array.isArray(steps) ? steps : [];
  return html`<div className="obj-wb__runtime" aria-label="Runtime readiness">
    <div className="obj-wb__runtime-track">
      ${rows.map((s, i) => html`<span key=${s.id} className="obj-wb__node" data-on=${s.on ? "1" : "0"} data-id=${s.id}>
        <i aria-hidden="true">${s.on ? "✓" : (i + 1)}</i>
        <em>${s.label}</em>
      </span>`)}
    </div>
    ${next ? html`<p className="obj-wb__next">${next}</p>` : null}
  </div>`;
}

export function WorkbenchHead({ eyebrow, title, say, object, heading = "h2" }) {
  const Tag = heading === "h1" ? "h1" : "h2";
  return html`<header className="obj-wb__head">
    <div>
      <p className="eyebrow">${eyebrow || ""}</p>
      <${Tag}>${title}<//>
      <p>${say || ""}</p>
    </div>
    ${object || null}
  </header>`;
}

export function StaggerIn({ children, delay = 0 }) {
  return html`<${M.div} initial=${{ opacity: 0, y: 10 }} animate=${{ opacity: 1, y: 0 }}
    transition=${{ ...SOFT, delay }}>${children}<//>`;
}

export default { PrepSpine, ObjectCard, RuntimeRail, WorkbenchHead, StaggerIn };
